// DashboardPage.tsx

import React, { FC, useEffect, useState, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import BGPRoutingTable from '../../modules/custom/Dashboard/components/BGPRoutingTable'
import Statusaws from '../../modules/custom/Dashboard/components/Status_Aws'
import StatusCtx from '../../modules/custom/Dashboard/components/Satus_CTX'
import StatusConnector from '../../modules/custom/Dashboard/components/status_Conector'
import Statussesiones from '../../modules/custom/Dashboard/components/Status_sesiones'
import DataUsage from '../../modules/custom/Dashboard/components/DataUsage'
import { useAuth } from '../../modules/auth'
import { useLocation } from 'react-router-dom'
import Topology from '../../modules/custom/Dashboard/components/Topology'
import axios from 'axios'
import { getsuscription, getsuscriptionglobal } from '../../modules/custom/Dashboard/requests/request'
import { useAppSelector } from '../../../redux/hooks'
import { DemoModal } from '../../Modal_Demo/ViewModalDemo'
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

const DashboardPage: React.FC = () => {
  const [flag, setflag] = useState(1)
  const { currentUser } = useAuth()
  const [imagen, setimagen] = useState<string | null>(null)
  const [err, seterr] = useState<string | null>(null)
  const [ID, setID] = useState<ID>(undefined)
  const [loading, setLoading] = useState(true) // Estado de loading
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const navigate = useNavigate() // Hook para redireccionar
  const location = useLocation()
  const [suscription, setsuscription] = useState([])

  // Manejar la suscripción y las imágenes de la topología
  const handlesus = useCallback(async () => {
    const tenantParam = tenant !== 0 ? `?tenantId=${tenant}` : ''
    try {
      const response = await axios.get(
        `${API_URL}/v1/suscription/${Id}/topology${tenantParam}`,
        { responseType: 'blob' }
      )

      const contentType = response.headers['content-type']

      if (contentType.includes('application/json')) {
        seterr('error')
        setimagen(null) // Reset image
      } else if (contentType.includes('image')) {
        const src = URL.createObjectURL(response.data)
        setimagen(src)
        seterr(null) // Reset error
      } else {
        seterr('error')
        setimagen(null)
      }
    } catch (error) {
      console.error('Error in handlesus:', error)
      seterr('error')
      setimagen(null)
    }
  }, [Id, tenant])

  // Obtener la lista de suscripciones (si aún es necesario)
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Type !== 'Global') {
          const instancias = tenant === 0 ? await getsuscription() : await getsuscriptionglobal(tenant)
          setsuscription(instancias.data)
        } else if (Id === 0 && Type === 'Global') {
          const instancias = tenant === 0 ? await getsuscription() : await getsuscriptionglobal(tenant)
          setsuscription(instancias.data)
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error)
      }
    }
    fetchData()
  }, [Id, Type, tenant])

  // Redirigir si no se tienen los permisos adecuados
  useEffect(() => {
    // Si ya estamos en la ruta '/dashboard/status' y tenemos el permiso, no hacemos nada más
    if (location.pathname.startsWith('/dashboard') && ListaPermisosTenant.includes('Home.Status')) {
      setLoading(false)
      return
    }

    const delay = setTimeout(() => {
      if (ListaPermisosTenant.length > 0) {
        setLoading(false) // Cambiar el estado de loading cuando los permisos estén cargados

        // Si tiene permiso 'CC.View' y no está en la ruta correcta, redirigimos
        if (ListaPermisosTenant.includes('CC.View') && location.pathname !== '/cloudConnectivity') {
          navigate('/cloudConnectivity')
        }
        // Si tiene permiso 'CTXR.GeneralStatus' y no está en la ruta correcta, redirigimos
        else if (ListaPermisosTenant.includes('CTXR.GeneralStatus') && location.pathname !== '/CTX-R/status') {
          navigate('/CTX-R/status')
        }
      }
    }, 1000) // Retraso de 1 segundo

    // Limpiar timeout si el componente se desmonta
    return () => clearTimeout(delay)
  }, [ListaPermisosTenant, navigate, location.pathname])

  // Llamar a handlesus cuando la ruta cambie a 'topology'
  useEffect(() => {
    if (location.pathname.endsWith('/topology') && Id) {
      handlesus()
    }
  }, [location.pathname, Id, handlesus])

  // Mostrar spinner mientras carga
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}
      >
        <Spinner animation='border' role='status' variant='primary'>
          <span className='visually-hidden'>Loading...</span>
        </Spinner>
        <div
          className='text-marino'
          style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}
        >
          We are validating your permissions...
        </div>
      </div>
    )
  }

  return (
    <div className='card mb-5 mb-xl-5'>
      {currentUser?.is_demo && <DemoModal setID={setID} />}
      <ul
        style={{ marginLeft: '25px', marginRight: '25px' }}
        className='nav nav-tabs nav-line-tabs mb-5 fs-6'
      >
        <li className='nav-item'>
          <NavLink
            className={({ isActive }) => `nav-link f-parrafo fs-p ${isActive ? 'active' : ''}`}
            to='status'
            onClick={() => setflag(1)}
          >
            Status
          </NavLink>
        </li>
        {(currentUser?.ListPermiso?.includes('Home.DataUsage') ||
          !ListaPermisosTenant.includes('Home.DataUsage')) && (
          <li className='nav-item'>
            <NavLink
              className={({ isActive }) => `nav-link f-parrafo fs-p ${isActive ? 'active' : ''}`}
              to='data-usage'
              onClick={() => setflag(2)}
            >
              Data Usage
            </NavLink>
          </li>
        )}
        {(currentUser?.ListPermiso?.includes('Home.Networking') ||
          !ListaPermisosTenant.includes('Home.Networking')) && (
          <li className='nav-item'>
            <NavLink
              className={({ isActive }) => `nav-link f-parrafo fs-p ${isActive ? 'active' : ''}`}
              to='networking'
              onClick={() => setflag(3)}
            >
              Networking
            </NavLink>
          </li>
        )}
        {(currentUser?.ListPermiso?.includes('Home.Topology') ||
          !ListaPermisosTenant.includes('Home.Topology')) && (
          <li className='nav-item'>
            <NavLink
              className={({ isActive }) => `nav-link f-parrafo fs-p ${isActive ? 'active' : ''}`}
              to='topology'
            >
              Topology
            </NavLink>
          </li>
        )}
      </ul>
      <div
        style={{ marginLeft: '25px', marginRight: '25px' }}
        className='tab-content'
        id='myTabContent'
      >
        <Routes>
          <Route
            path='status'
            element={
              <div className='app-container container-fluid'>
                <div className='row'>
                  <div className='col-md-6' style={{ marginBottom: '15px' }}>
                    <Statusaws id={flag}></Statusaws>
                  </div>
                  <div className='col-md-6' style={{ marginBottom: '15px' }}>
                    <StatusCtx id={flag}></StatusCtx>
                  </div>
                  <div className='col-md-6' style={{ marginBottom: '15px' }}>
                    <StatusConnector id={flag}></StatusConnector>
                  </div>
                  <div className='col-md-6' style={{ marginBottom: '15px' }}>
                    <Statussesiones id={flag}></Statussesiones>
                  </div>
                </div>
              </div>
            }
          />
          {(currentUser?.ListPermiso?.includes('Home.DataUsage') ||
            !ListaPermisosTenant.includes('Home.DataUsage')) && (
            <Route path='data-usage' element={<DataUsage id={flag}></DataUsage>} />
          )}
          {(currentUser?.ListPermiso?.includes('Home.Networking') ||
            !ListaPermisosTenant.includes('Home.Networking')) && (
            <Route path='networking' element={<BGPRoutingTable id={flag}></BGPRoutingTable>} />
          )}
          {(currentUser?.ListPermiso?.includes('Home.Topology') ||
            !ListaPermisosTenant.includes('Home.Topology')) && (
            <Route path='topology' element={<Topology img={imagen} err={err}></Topology>} />
          )}
          <Route path='*' element={<Navigate to='status' />} />
        </Routes>
      </div>
      {ID !== undefined && <DemoModal setID={setID} id={ID} />}
    </div>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
